module.exports = __webpack_public_path__ + "img/debtPayingAbility7.c23df240.png";